/* PANTHERATEC | Dynamic Fera rating in the Concept announcement carousel.
   No hard-coded reviews. Preserves original Fera verification interaction.
   Re-initializes on Shopify theme-editor section reloads. */
(function () {
  'use strict';

  if (window.__ptFeraAnnouncementBound) return;
  window.__ptFeraAnnouncementBound = true;

  function textOf(element) {
    return ((element && (element.innerText || element.textContent)) || '')
      .replace(/\s+/g, ' ').trim();
  }

  function extractScore(widget, text) {
    var element = widget.querySelector('[itemprop="ratingValue"], [data-rating-value]');
    var raw = element && (
      element.getAttribute('content') ||
      element.getAttribute('data-rating-value') || element.textContent
    );
    if (!raw) {
      var match = text.match(/(?:^|[^\d])([1-5][.,]\d{1,2})(?=[^\d]|$)/);
      raw = match && match[1];
    }
    if (!raw) {
      var whole = text.match(/(?:Gesamtbewertung|Overall rating|Rating)[^\d]{0,25}([1-5])(?:\s|$)/i);
      raw = whole && whole[1];
    }
    var value = Number(String(raw || '').trim().replace(',', '.'));
    return value >= 1 && value <= 5 ? value : null;
  }

  function extractCount(widget, text) {
    var element = widget.querySelector('[itemprop="reviewCount"], [data-review-count]');
    var raw = element && (
      element.getAttribute('content') ||
      element.getAttribute('data-review-count') || element.textContent
    );
    if (!raw) {
      var match = text.match(/(\d[\d.,\s]*)\s*(?:(?:Kunden|Customer|Store|Shop)\s*)?(?:Rezension\w*|Bewertung\w*|Reviews?|Ratings?)/i);
      raw = match && match[1];
    }
    var value = parseInt(String(raw || '').replace(/[^\d]/g, ''), 10);
    return Number.isSafeInteger(value) && value > 0 ? value : null;
  }

  function findNativeVerify(widget) {
    var matches = widget.querySelectorAll([
      '[aria-label*="verif" i]', '[aria-label*="prüf" i]',
      '[title*="verif" i]', '[title*="prüf" i]',
      '[class*="verification" i]', '[class*="verified" i]',
      '[class*="verify" i]', '[data-fera-verification]',
      '[aria-haspopup="dialog"]'
    ].join(','));
    for (var i = 0; i < matches.length; i++) {
      var node = matches[i];
      var target = node.closest('button, a, [role="button"]');
      if (target && widget.contains(target)) return target;
      if (node.matches('button, a, [role="button"]')) return node;
      // Some Fera versions use a span/SVG with a delegated click listener.
      if (node.matches('span, div, svg')) return node;
    }
    return null;
  }

  function initialize(host) {
    if (host.dataset.ptFeraInitialized === 'true') return;
    var widget = host.querySelector('[data-pt-fera-source] [data-fera-widget]');
    var display = host.querySelector('[data-pt-fera-display]');
    var scoreElement = host.querySelector('[data-pt-fera-score]');
    var countElement = host.querySelector('[data-pt-fera-count]');
    var stars = host.querySelector('[data-pt-fera-stars]');
    var verify = host.querySelector('[data-pt-fera-verify]');
    if (!widget || !display || !scoreElement || !countElement || !stars || !verify) return;

    host.dataset.ptFeraInitialized = 'true';
    var activeVerify = null;

    function update() {
      var text = textOf(widget);
      var score = extractScore(widget, text);
      var count = extractCount(widget, text);
      if (score === null || count === null) {
        display.hidden = true;
        host.dataset.ptFeraState = 'loading';
        return;
      }
      scoreElement.textContent = score.toLocaleString('de-DE', {
        minimumFractionDigits: 1, maximumFractionDigits: 1
      });
      countElement.textContent = count.toLocaleString('de-DE') +
        (count === 1 ? ' Rezension' : ' Rezensionen');
      stars.style.width = (score / 5 * 100).toFixed(2) + '%';
      display.setAttribute('aria-label',
        scoreElement.textContent + ' von 5 Sternen bei ' + countElement.textContent
      );
      activeVerify = findNativeVerify(widget);
      verify.hidden = !activeVerify;
      display.hidden = false;
      host.dataset.ptFeraState = 'ready';
    }

    verify.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      activeVerify = findNativeVerify(widget);
      if (!activeVerify) return;
      activeVerify.dispatchEvent(new MouseEvent('click', {
        bubbles: true, cancelable: true, composed: true, view: window
      }));
    });

    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        update();
      });
    });
    observer.observe(widget, {childList: true, subtree: true, characterData: true});
    update();
  }

  function init(root) {
    (root || document).querySelectorAll('[data-pt-announce-fera]').forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else init(document);

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();
